import { render, staticRenderFns } from "./PxButton.vue?vue&type=template&id=5af48dce&"
import script from "./PxButton.vue?vue&type=script&lang=js&"
export * from "./PxButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports